import { render } from "./TermsSection.vue?vue&type=template&id=7e931730&scoped=true"
import script from "./TermsSection.vue?vue&type=script&lang=js"
export * from "./TermsSection.vue?vue&type=script&lang=js"

import "./TermsSection.vue?vue&type=style&index=0&id=7e931730&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e931730"]])

export default __exports__